goog.provide('el8.shared.util.passwordHelp');

var el8 = el8 || {};
if(!el8.shared) { el8.shared = {}; }
if(!el8.shared.util) { el8.shared.util = {}; }

el8.shared.util.passwordHelp = (function() {

    var that = {};
    var theForm = null;
    var minChars = 8;

    that.renderCheckState = function(ele, isSuccess) {
        if (isSuccess) {
            if (ele.hasClass('el8ValidationFail')) {
                ele.removeClass('el8ValidationFail');
            }
            if (!ele.hasClass('el8ValidationSuccess')) {
                ele.addClass('el8ValidationSuccess');
            }
        } else {
            if (ele.hasClass('el8ValidationSuccess')) {
                ele.removeClass('el8ValidationSuccess');
            }
            if (!ele.hasClass('el8ValidationFail')) {
                ele.addClass('el8ValidationFail');
            }
        }
    };

    that.clearCheckState = function(ele) {
        ele.removeClass('el8ValidationSuccess');
        ele.removeClass('el8ValidationFail');
    };

    that.clearCheckState = function(ele) {
        ele.removeClass('el8ValidationFail').removeClass('el8ValidationSuccess');
    };

    that.passwordCheck1 = function(password1) {
        return password1.length >= minChars;
    };

    that.passwordCheck2 = function(password1) {
        return password1.match(/\d+/g) !== null || password1.match(/[^\w\s]/gi) !== null || password1.match(/[_]/gi) !== null;
    };

    that.renderPasswordHelpChecks = function() {
        // render the state of the varies password checks depending on the actual password entered
        var password1 = theForm.getVal('password1');

        if (password1.length === 0) {
            that.clearCheckState($('#min-number-char'));
            that.clearCheckState($('#at-least-one-number-or-special-char'));
            return;
        }
        that.renderCheckState($('#min-number-char'), that.passwordCheck1(password1));
        that.renderCheckState($('#at-least-one-number-or-special-char'), that.passwordCheck2(password1));
    };

    that.renderPasswordHelp = function(show) {
        // render the actualy state of the passwor help popup
        that.renderPasswordHelpChecks();

        if (show) {
            $('.password-help').show();
        } else {
            $('.password-help').hide();
        }
    };

    that.setupPasswordHelp = function() {
        var password1Select = ':input[name="password1"]';
        var password2Select = ':input[name="password2"]';

        $(document).on('focus', password1Select, function(event) {
            that.renderPasswordHelp(true);
        });
        $(document).on('blur', password1Select, function(event) {
            that.renderPasswordHelp(false);
        });

        $(document).on('keyup', password1Select, function(event) {
            that.renderPasswordHelpChecks();
        });

        $(document).on('focus', password2Select, function(event) {
            $('.password-match').hide();
        });

        $(document).on('blur', password2Select, function(event) {
            if (!theForm.getVal('password2') || (theForm.getVal('password1') === theForm.getVal('password2'))) {
                $('.password-match').hide();
            } else {
                $('.password-match').show();
            }
        });
        $('.password-match').hide();
        that.renderPasswordHelp(false);
    };

    that.init = function(targetForm, spec) {
        theForm = targetForm;
        if (!spec) { spec = {}; }
        if (spec.minChars) {
            minChars = spec.minChars;
        }
    };

    return that;

})();